<lib-page-layout>
  <lib-home-navbar
    pageHeader
    extended
    (onAddGameOpened)="goToGameCreator()"
    [isNewNotifications]="!!isNewNotifications()"
    [showFiltersIcon]="false"></lib-home-navbar>

  <!--  <div pageHeader class="dashboard-top-container"></div>-->

  <div pageHeader class="margin-top--36-px z-index-999">
    <lib-dashboard-navbar></lib-dashboard-navbar>
  </div>

  <lib-dashboard-messages></lib-dashboard-messages>

  @if (!isEmptyStateVisible()) {
    @if (isUpcomingLoading() || hasUpcomingGames()) {
      <div class="or-d-flex or-justify-content-between or-align-items-center or-px-24-px or-mt-20-px">
        <div class="or-head-md">Twoje najbliższe gierki</div>
        @if (!isUpcomingLoading()) {
          <div (click)="goToMyGames()" class="or-text-md or-color-main-1 or-cursor-pointer">
            Wszystkie ({{ upcomingGamesCount() > 99 ? '99+' : upcomingGamesCount() }})
          </div>
        }
      </div>
    }

    <lib-dashboard-invitations
      (isInvitationsAvailable)="setIsInvitationsAvailable($event)"
      (invitationsCount)="setInvitationsCount($event)"
      (invitationAccepted)="invitationAccepted()"></lib-dashboard-invitations>

    <lib-dashboard-games-list
      (isGameAvailable)="setIsGameAvailable($event)"
      (gamesCount)="setGamesCount($event)"
      (loadingChange)="setUpcomingLoading($event)"></lib-dashboard-games-list>
  } @else {
    <lib-dashboard-empty-state></lib-dashboard-empty-state>
  }

  <lib-dashboard-teams [teams]="teams()"></lib-dashboard-teams>

  <lib-create-team [teams]="teams()"></lib-create-team>

  <lib-dashboard-contact></lib-dashboard-contact>

  <lib-bottom-navbar pageFooter></lib-bottom-navbar>
</lib-page-layout>
